import DB from "@/common/utils/db";
/**
 * @description 获取订单列表
 */
export function getUserInfo() {
  return DB({
    url: "v1/users/getUserInfo",
    method: "get"
  });
}
/**
 * @description 获取订单列表
 */
export function getCandidateList(query) {
  return DB({
    url: "v1/candidates",
    method: "get",
    params: query
  });
}
/**
 * @description 获取订单列表统计数量
 */
export function getCandidateCount(query) {
  return DB({
    url: "v1/candidates/count",
    method: "get",
    params: query
  });
}
/**
 * @description 获取订单详情
 */
export function getCandidateDetail(id) {
  return DB({
    url: "v1/candidates/" + id,
    method: "get"
  });
}
/**
 * @description 获取订单推荐报告
 */
export function getCandidateReport(id) {
  return DB({
    url: "v1/candidates/" + id + '/recomentReport',
    method: "get"
  });
}
/**
 * @description 获取候选人标签
 */
export function getTalentTag(query) {
  return DB({
    url: "v1/talents/tagBaseViews",
    method: "get",
    params: query
  });
}
/**
 * @description 获取OS
 */
export function getOsUser(query) {
  return DB({
    url: "v1/positions/getOsUser",
    method: "get",
    params: query
  });
}